import CommonFunctions from "./CommonFunctions";

export default class ValidationHelper {
    static validatePictureUploadResult(e) {
        const files = e.files;
        const maxFileSizeInBytes = 1024 * 1024; // 1 MB
        let valid = true;
        $.each(files,
            (index, element) => {
                if (element.extension.toLowerCase() !== ".png"
                    && element.extension.toLowerCase() !== ".jpg"
                    && element.extension.toLowerCase() !== ".jpeg"
                    && element.extension.toLowerCase() !== ".bmp"
                    && element.extension.toLowerCase() !== ".gif") {
                    CommonFunctions.showError(TextResources.Views_Fehler, TextResources.Error_OnlyPictureAllowed);
                    e.preventDefault();
                    valid = false;
                }

                if (element.size > maxFileSizeInBytes) {
                    CommonFunctions.showError(TextResources.Views_Fehler, kendo.format(TextResources.Error_MaxFileSizeExceeded, CommonFunctions.formatFileSize(maxFileSizeInBytes)));
                    e.preventDefault();
                    valid = false;
                }
            });
        return valid;
    }
}
